export default __webpack_public_path__ + "static/media/MYRIADPRO-SEMIBOLD.662f3601.OTF";